/**
 * Session JWT in localStorage: plain string (current).
 * Legacy: JSON string { successtype, success } — still read for migration.
 */
export function readSessionToken() {
  const raw = localStorage.getItem('SESSION_TOKEN');
  if (!raw) {
    return null;
  }
  const trimmed = raw.trim();
  if (trimmed.startsWith('{')) {
    try {
      const data = JSON.parse(raw);
      return typeof data?.success === 'string' ? data.success : null;
    } catch {
      return null;
    }
  }
  return raw;
}

export function writeSessionToken(token) {
  if (token) {
    localStorage.setItem('SESSION_TOKEN', token);
  } else {
    localStorage.removeItem('SESSION_TOKEN');
  }
}
